module.exports = __webpack_public_path__ + "static/img/storage03.31449dc5.png";